import { render, staticRenderFns } from "./CollectionCardTrailer.vue?vue&type=template&id=3d54f766&scoped=true"
import script from "./CollectionCardTrailer.vue?vue&type=script&lang=js"
export * from "./CollectionCardTrailer.vue?vue&type=script&lang=js"
import style0 from "./CollectionCardTrailer.vue?vue&type=style&index=0&id=3d54f766&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d54f766",
  null
  
)

export default component.exports